export default "__VITE_ASSET__BTz80jWM__"